import { ReactNode } from "react";
import styles from "./EntityIdentityRow.module.css";

export type EntityIdentityRowProps = {
  icon: ReactNode;
  name: string;
};

/**
 * Compact "icon + name" row — the shared shape behind `CustomerIdentityRow`
 * (Home's `TrackingHeader`, Customer Details) and Service Details' summary
 * row. Takes the icon as a node rather than a fixed glyph since Customer's
 * icon is a static `UserIcon` but Service's is a merchant-configured image
 * URL — everything else about the row is identical either way.
 */
export const EntityIdentityRow = ({ icon, name }: EntityIdentityRowProps) => (
  <div className={styles.row}>
    {icon}
    <span className={styles.name}>{name}</span>
  </div>
);
